export default  {"src":"/_next/static/image/public/assets/icons/up-arrow.86761175bedc3531eee4b86155a4ed4c.svg","height":330,"width":330};